<template>
    <div class="qixi_container">
        <headerWX class="headerWX"></headerWX>
        <div class="content">
            <img class="bg" src="@/assets/imgs/Qixi/bg.png" alt="" />
            <div style="height: 120px"></div>


            <!-- 抽奖 -->
            <div class="Lottery pubile">
                <div class="tit">
                    <div class="lift">
                        <img src="@/assets/imgs/Qixi/Rules.png" alt="" @click="openModal('Rules')" />
                        <img src="@/assets/imgs/Qixi/Record.png" alt="" @click="openModal('Record')" />
                        <!-- <img src="@/assets/imgs/chidrenDay/Ranking.png" alt="" @click="openModal('Ranking')" /> -->
                        <img src="@/assets/imgs/Qixi/PrizePool.png" alt="" @click="openModal('PrizePool')" />
                        <img src="@/assets/imgs/Qixi/Ranking.png" alt="" @click="() => {
                            ispopUp = true;
                            ispopUpType = 'Ranking';
                        }" />
                    </div>
                    <img class="tit_bg" src="@/assets/imgs/Qixi/Lottery_tit.png" alt="" />
                    <div class="right">
                        <img src="@/assets/imgs/Qixi/Balance.png" alt="" />
                        <div class="coin">
                            <p class="coin_num">白金币：{{ getActivityList.drawTokenBalance }}</p>
                            <!-- <p class="coin_exchange" @click="openExchange">兑换</p> -->
                        </div>
                    </div>
                </div>
                <div class="LotteryContent">
                    <!-- <img class="LotteryContent_bg" src="@/assets/imgs/Qixi/LotteryContentBg.png" alt=""> -->
                    <div class="items">
                        <img class="jewelryBox" src="@/assets/imgs/Qixi/jewelryBox.png" alt="" />
                        <img class="jewelryBoxBg" src="@/assets/imgs/Qixi/jewelryBoxBg.png" alt="" />
                        <img class="jewelry" src="@/assets/imgs/Qixi/2.webp" alt="" />
                        <img class="bigPrize" src="@/assets/imgs/Qixi/bigPrize.gif" alt="" />
                    </div>
                </div>
                <div class="btn">
                    <div>
                        <img src="@/assets/imgs/Qixi/oneExtract.png" alt="" @click="openLotteryHit('one')" />
                        <p>本次消耗：{{ getActivityList.singleCost }}鹊舞签</p>
                    </div>
                    <div>
                        <img src="@/assets/imgs/Qixi/tenExtract.png" alt="" @click="openLotteryHit('ten')" />
                        <p>本次消耗：{{ getActivityList.tenCost }}鹊舞签</p>
                    </div>
                </div>
                <!-- 以获得的奖励道具 -->
                <div class="haveObtained">
                    <img class="haveObtained_bg" src="@/assets/imgs/Qixi/haveObtained_bg.png" />
                    <div class="haveObtained_list">
                        <div class="item"
                            v-for="value in [{ id: 1, value: 0 }, { id: 2, value: 0 }, { id: 3, value: 1 }, { id: 4, value: 1 }, { id: 5, value: 2 }, { id: 6, value: 2 }]"
                            :key="value.id">
                            <img v-if="value.id % 2 == 1" src="@/assets/imgs/Qixi/haveObtained_see.png" alt=""
                                @click="SeeExchangeRewardsFun(value)" />
                            <img v-else src="@/assets/imgs/Qixi/haveObtained_Exchange.png" alt=""
                                @click="openModal('ExchangeRewards', getActivityList.voucherList[value.value])" />
                        </div>
                    </div>
                </div>
            </div>


            <!-- 追加奖励 -->
            <div class="AdditionReward pubile">
                <div class="AdditionReward_tit">
                    <img src="@/assets/imgs/Qixi/AdditionReward_tit.png" alt="" />
                </div>
                <img src="@/assets/imgs/Qixi/AdditionReward_bg.png" alt="" />
                <div class="AdditionReward_items">
                    <div v-for="value in getActivityList.extraTaskList" :key="value.taskId">
                        <div class="lift_award">{{ value.taskName }}({{
                            value.status == 0 || getActivityList.totalDrawCount <= value.needCount ?
                                getActivityList.totalDrawCount : value.needCount }}/{{ value.needCount }}) </div>
                                <div class="right_btn">

                                    <div class="Reward">
                                        <div v-if="value.selectType == 'fixed'">
                                            <el-tooltip v-for="item in value.rewardList" :key="item.prizeId"
                                                :content="`${item.name}X${item.quantity}`" placement="top"
                                                effect="dark">
                                                <!-- <el-image style="max-width: 20%; max-height: 80%" :src="item.itemImg"
                                            :preview-src-list="[item.itemImg]" /> -->
                                                <img :src="item.itemImg" alt="" />
                                            </el-tooltip>
                                        </div>
                                        <div v-else-if="value.selectType == 'random'" class="random" @click="() => {
                                            openModal('SeeExchangeRewards', {
                                                allRewards: value.rewardList,
                                                level: '普通情侣戒指奖励查看'
                                            })
                                        }">
                                            查看奖励
                                        </div>

                                        <div v-else style="color: #D22190 ;font-weight: 700;">自选单品道具 X1</div>
                                    </div>

                                    <img v-if="value.status == 0" src="@/assets/imgs/Qixi/0.png" alt="">

                                    <img v-else-if="value.status == 1 && value.selectType == 'choose'"
                                        src="@/assets/imgs/Qixi/3.png" @click="openModal('RewardSelection', value)"
                                        alt="">

                                    <img v-else-if="value.status == 1" src="@/assets/imgs/Qixi/1.png"
                                        @click="RewardSelectionBuy(value, value)" alt="">

                                    <img v-else-if="value.status == 2" src="@/assets/imgs/Qixi/2.png" alt="">
                                    <!-- <button style="background-color: aqua" @click="openModal('RewardSelection',value)">
                            打开
                        </button> -->
                                </div>
                        </div>
                    </div>
                </div>
                <!-- 七夕签到-->
                <div class="signIn pubile">
                    <div class="signIn_tit">
                        <img src="@/assets/imgs/Qixi/signIn/title_qixi_signin.png" alt="" />
                    </div>
                    <img class="signIn_path_bg" src="@/assets/imgs/Qixi/signIn/signin_path_bg.png" alt="" />
                    <div class="signIn_items">
                        <img class="slot_empty" src="@/assets/imgs/Qixi/signIn/slot_empty.png" alt="" />
                        <div :class="['signIn_item', { 'active': value.canSign }]" v-for="value in modeList.signInList"
                            :key="value.dayNo" @click="signInFun(value)">
                            <template v-for="(i, index) in value.rewards">
                                <el-tooltip class="item" effect="dark" :content="`${i.name}X${i.quantity}`"
                                    placement="top">
                                    <div class="reward">
                                        <img class="item_img" :src="i.imageUrl">
                                        <img v-if="value.signed == true" class="icon_locked"
                                            src="@/assets/imgs/Qixi/signIn/tag_claimed.png" alt="">
                                        <img v-else-if="value.canMakeup == true" class="btn_resign"
                                            src="@/assets/imgs/Qixi/signIn/btn_resign.png" alt="" srcset="">
                                        <!-- 锁住 -->
                                        <img v-else-if="value.canSign !== true" class="icon_locked"
                                            src="@/assets/imgs/Qixi/signIn/icon_locked.png" alt="" />

                                    </div>
                                </el-tooltip>
                            </template>
                        </div>
                        <div :class="['signIn_item', { 'active': modeList.isFullAttendance }]"
                            @click="FullAttendanceFun()">
                            <el-tooltip class="item" effect="dark" content="自选" placement="top">
                                <div class="reward">
                                    自选奖励
                                    <img v-if="modeList.attendanceRewardClaimed == true" class="icon_locked"
                                        src="@/assets/imgs/Qixi/signIn/tag_claimed.png" alt="" />
                                    <img v-if="modeList.fullAttendance == false" class="icon_locked"
                                        src="@/assets/imgs/Qixi/signIn/icon_locked.png" alt="" />

                                </div>
                            </el-tooltip>
                        </div>
                    </div>
                    <!-- 切换模式 -->
                    <div class="signIn_mode">
                        <div class="mode_item" :class="{ active: modeType === 'COUPLE' }" @click="switchMode('COUPLE')">
                            <span class="dot"></span>
                            情侣模式
                        </div>

                        <div class="mode_item" :class="{ active: modeType === 'SISTER' }" @click="switchMode('SISTER')">
                            <span class="dot"></span>
                            闺蜜模式
                        </div>
                    </div>
                </div>


                <!-- 累计任务 -->
                <div class="DailyTasks pubile">
                    <div class="DailyTasks_tit">
                        <img src="@/assets/imgs/Qixi/Tasks/Cumulative_tasks_title.png" alt="" />
                    </div>
                    <img class="DailyTasks_bg" src="@/assets/imgs/Qixi/Tasks/Cumulative_tasks_bg.png" alt="" />
                    <div class="DailyTasks_items">
                        <div class="item" v-for="(item, index) in modeList.cumulativeTaskList" :key="index">
                            <div class="left">
                                累计签到 {{ item.needDays }}天
                            </div>
                            <div class="right">
                                <div class="right_Reward">
                                    <!-- 第一层：先判断类型 (v-if) -->
                                    <template v-if="item.selectType == 'fixed'">
                                        <!-- 第二层：如果是固定奖励，再遍历列表 (v-for) -->
                                        <!-- 注意：key 是必须的，建议加上 -->
                                        <el-tooltip v-for="(i, index) in item.rewardList" :key="index"
                                            :content="`${i.name}X${i.quantity}`" placement="top" effect="dark">
                                            <img :src="i.imageUrl" alt="">
                                        </el-tooltip>
                                    </template>

                                    <!-- 否则：显示随机奖励 -->
                                    <template v-else>
                                        <div class="random" @click="() => {
                                            openModal('SeeExchangeRewards', {
                                                allRewards: item.rewardList,
                                                level: `累计签到7天奖励查看`
                                            })
                                        }">
                                            查看奖励
                                        </div>
                                    </template>
                                </div>

                                <div class="right_Btn">
                                    <img v-if="item.status == 0" src="@/assets/imgs/Qixi/0.png" alt="">
                                    <img @click="CumulativeTaskTasksFun(item)" v-else-if="item.status == 1"
                                        src="@/assets/imgs/Qixi/1.png" alt="">
                                    <img v-else-if="item.status == 2" src="@/assets/imgs/Qixi/2.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- 每日任务 -->
                <div class="DailyTasks pubile">
                    <div class="DailyTasks_tit">
                        <img src="@/assets/imgs/Qixi/Tasks/daily_task_title.png" alt="" />
                    </div>
                    <img class="DailyTasks_bg" src="@/assets/imgs/Qixi/Tasks/daily_task_bg.png" alt="" />
                    <div class="DailyTasks_items">
                        <div class="item" v-for="(item, index) in modeList.dailyTaskList" :key="index">
                            <div class="left">
                                {{ item.taskName }}
                            </div>
                            <div class="right">
                                <div class="right_Reward">
                                    <el-tooltip :content="`${item.rewardName}X${item.rewardNum}`" placement="top"
                                        effect="dark">
                                        <img :src="item.rewardImg" alt="">
                                    </el-tooltip>
                                </div>
                                <div class="right_Btn">
                                    <img v-if="item.status == 0" src="@/assets/imgs/Qixi/0.png" alt="">
                                    <img v-else-if="item.status == 1" src="@/assets/imgs/Qixi/1.png" alt=""
                                        @click="DailyTasksFun(item)">
                                    <img v-else-if="item.status == 2" src="@/assets/imgs/Qixi/2.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




                <!-- 心直购 -->
                <div class="directPurchasing">
                    <div class="directPurchasing_tit">
                        <img src="@/assets/imgs/Qixi/directPurchasing/directPurchasing_tit.png" alt="" />
                    </div>
                    <div class="directPurchasing_num directPurchasing_tit">
                        <img src="@/assets/imgs/Qixi/Balance.png" alt="" />
                        <div class="n_l">
                            <div v-if="modeType == 'COUPLE'">情侣红心：{{ getActivityList.totalCoupleHeart }}
                            </div>
                            <div v-else>蜜糖之心：{{ getActivityList.totalSisterHeart }}</div>
                        </div>
                    </div>
                    <div class="directPurchasing_items">
                        <div class="directPurchasing_item" v-for="(value, index) in modeList.directPurchasing"
                            :key="value.packageId">
                            <img src="@/assets/imgs/Qixi/directPurchasing/bg.png" alt="" srcset="">
                            <div class="Content">
                                <img v-if="index == 0" src="@/assets/imgs/Qixi/directPurchasing/1.png" alt="" srcset="">
                                <img v-else-if="index == 1" src="@/assets/imgs/Qixi/directPurchasing/2.png" alt=""
                                    srcset="">
                                <img v-else src="@/assets/imgs/Qixi/directPurchasing/3.png" alt="" srcset="">
                                <p>{{ value.heartName }} * {{ value.heartNum }}</p>
                            </div>
                            <!-- 按钮 -->
                            <img class="btn" src="@/assets/imgs/Qixi/directPurchasing/buy1.png"
                                @click="openModal('directPurchasing', value)">
                        </div>
                    </div>

                </div>

                <!-- 金铃铛-->
                <div class="Goldenbell">
                    <img src="@/assets/imgs/Qixi/Goldenbell_bg.png" alt="" />
                    <div class="numberBady">
                        <div class="n_l">{{ getActivityList.exchangeTokenBalance }}</div>
                        <div class="n_c">{{ getActivityList.exchangeTokenUsed }}</div>
                        <div class="n_r">{{ getActivityList.exchangeTokenTotal }}</div>
                    </div>
                </div>

                <!-- 暖冬商店 -->
                <div class="WinterStore">
                    <div class="tit">
                        <img src="@/assets/imgs/Qixi/WinterStore_tit.png" alt="" />
                    </div>
                    <div class="shopBady">
                        <div class="item" v-for="(item, index) in getActivityData" :key="index">
                            <img style="width: 100%;" src="@/assets/imgs/Qixi/shop_bady.png" alt="" />
                            <div class="item_btn">
                                <div v-if="item.shortageText" class="shortageText">
                                    {{ item.shortageText }}
                                </div>
                                <img v-else-if="item.status == 2" src="@/assets/imgs/Qixi/shop_btn_end.png" />
                                <!-- <img v-else-if="item.status == 0" style="filter: grayscale(100%)"
                                src="@/assets/imgs/Qixi/shop_btn_get.png" alt="" /> -->
                                <img v-else-if="item.status == 1" src="@/assets/imgs/Qixi/shop_btn_get.png"
                                    @click="goShop_pop(item)" alt="" />

                            </div>

                            <div class="item_number">
                                <template v-if="item.limitCount != 0">
                                    ({{ item.buyCount ? item.buyCount : 0 }}/{{
                                        item.limitCount ? item.limitCount : 0
                                    }})
                                </template>

                            </div>
                            <!-- <div class="item_number" v-else>
                            ({{ item.boughtNum ? item.boughtNum : 0 }})
                        </div> -->

                            <div class="itemBady">
                                <div class="itemBady_t">
                                    <img src="@/assets/imgs/Qixi/gold_icon.png" alt="" />
                                    <p>&nbsp;X {{ item.price }}</p>
                                </div>
                                <div class="itemBady_c">
                                    <div class="sex">
                                        <img v-if="item.sex == 1" src="@/assets/imgs/Qixi/userSex1.png" alt="" />
                                        <img v-else-if="item.sex == 2" src="@/assets/imgs/Qixi/userSex2.png" alt="" />
                                        <img v-else-if="item.sex == 3" src="@/assets/imgs/chidrenDay/userSex3.png"
                                            alt="" />
                                        <img v-else src="@/assets/imgs/chidrenDay/userSex4.png" alt="" />
                                    </div>
                                    <el-tooltip class="item" effect="dark" :content="item.itemName" placement="top">
                                        <img :src="item.itemImg" alt="" />
                                        <!-- <el-image style="width: 100%; height: 100%" :src="item.img"
                                        :preview-src-list="[item.img]" /> -->
                                    </el-tooltip>
                                </div>
                                <div class="itemBady_b">{{ item.itemName }}
                                    <template v-if="item.num > 1">
                                        X{{ item.num }}
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <footerWX class="footerWX"></footerWX>

            <!-- 二次确认弹窗 -->
            <div id="mask" v-if="ispopUp">
                <div style="
          position: fixed;
          top: 13%;
          left: 50%;
          transform: translateX(-50%);
          /* width: 30vw; */
          height: 70vh;
          min-height: 500px;
          min-width: 700px;
          /* background: linear-gradient(#d7b7ff, #f9f8ff); */
          z-index: 9999;
        ">
                    <popUp v-if="ispopUpType == 'popUp'" style="" @ispopUp="TzpopUp" propShow="3"
                        :DBF_goShop="DBF_goShop">
                    </popUp>

                    <PublicPopUp v-else-if="ispopUpType == 'PublicPopUp'" :seeData="seeData" :seeType="seeType"
                        @closeModal="closeModal" @seeConfirm="seeConfirm" @seeReward="seeReward"></PublicPopUp>

                    <Ranking v-else-if="ispopUpType == 'Ranking'" @closeModal="closeModal"></Ranking>
                </div>
            </div>


            <!-- 抽奖特效 -->
            <LotteryModal ref="cgModalRef" @LotteryModalOK="LotteryModalOK" />

            <div class="top"></div>
        </div>
</template>

<script>
import headerWX from "@/components/Header";
import footerWX from "@/components/Footer";
import axios from "axios";
import Cookies from "js-cookie";
import popUp from "@/components/pop_up";
import PublicPopUp from "./component/PublicPopUp.vue";
import orderMask from "./component/orderModal.vue";
import router from "@/router";
import LotteryModal from "./component/LotteryModal.vue";
import Ranking from "./component/Ranking.vue";

export default {
    name: "QixiIndex",
    components: {
        headerWX,
        footerWX,
        popUp,
        PublicPopUp,
        orderMask,
        LotteryModal,
        Ranking,
    },
    data() {
        return {
            // 每日任务 挑战任务数据
            getActivityList: {},
            //金 剩余 总共 使用
            totalData: {},
            // 商品数据
            getActivityData: [],

            ispopUp: false,
            DBF_goShop: "",
            ispopUpType: "", //蒙版类型
            seeType: "",
            seeData: "",

            // 付费签到奖励
            extraRewards: [],
            // 免费签到奖励
            normalRewards: [],

            isSignClickable: true, // 点击状态锁
            loading: null,



            modeType: "COUPLE", //当前模式类型  SISTER=闺蜜模式 COUPLE=情侣模式
            modeList: {
                signInList: [],//签到列表
                dailyTaskList: [],//每日任务
                cumulativeTaskList: [],//累计任务
                directPurchasing: [], // 直接购买奖励
                fullAttendance: false, // 是否完成全勤
                canClaimAttendanceReward: false, // 是否完成全勤
                attendanceRewardClaimed: false, // 是否完成全勤
                fullAttendanceList: [], // 全勤奖励
            }

        };
    },
    created() {
        this.init();

        this.openPageScroll();

    },
    mounted() {
        // this.$refs.cgModalRef.show({
        //     name: '清凉碎片',
        //     count: 10
        // })
    },

    methods: {

        // 切换模式
        switchMode(type) {
            const modeSignList = this.getActivityList.signConfig.modeSignList
            if (type == "COUPLE") {
                this.modeList = {
                    signInList: modeSignList[0].days,
                    dailyTaskList: this.getActivityList.dailyTaskList[0].tasks,
                    cumulativeTaskList: this.getActivityList.cumulativeTaskList[0].tasks,
                    directPurchasing: this.getActivityList.coupleHeartPackageList,
                    fullAttendance: modeSignList[0].fullAttendance,
                    canClaimAttendanceReward: modeSignList[0].canClaimAttendanceReward,
                    attendanceRewardClaimed: modeSignList[0].attendanceRewardClaimed,
                    fullAttendanceList: modeSignList[0].attendanceRewards[0].rings
                }
            } else if (type == "SISTER") {
                this.modeList = {
                    signInList: modeSignList[1].days,
                    dailyTaskList: this.getActivityList.dailyTaskList[1].tasks,
                    cumulativeTaskList: this.getActivityList.cumulativeTaskList[1].tasks,
                    directPurchasing: this.getActivityList.sisterHeartPackageList,
                    fullAttendance: modeSignList[1].fullAttendance,
                    canClaimAttendanceReward: modeSignList[1].canClaimAttendanceReward,
                    attendanceRewardClaimed: modeSignList[1].attendanceRewardClaimed,
                    fullAttendanceList: modeSignList[1].attendanceRewards[0].rings
                }
            }
            this.modeType = type
        },
        // 签到
        signInFun(value) {
            if (value.canMakeup == true) {
                this.openModal('buqian', value)
                return
            }
            if (value.canSign !== true) {
                return
            } 
            this.loading = this.$loading({
                // lock: true,
                text: '签到中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            axios({
                method: "post",
                url: "/activityV2/sign",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    signMode: this.modeType,
                    dayNo: value.dayNo,
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        this.init();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                })
                .finally(() => {
                    this.loading.close()
                })
        },

        // 查看已经获得的 S A B 等级奖励
        SeeExchangeRewardsFun(value) {

            this.loading = this.$loading({
                // lock: true,
                text: '查看中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            axios({
                method: "post",
                url: "/activityV2/getVoucherExchangeRecords",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    level: value.value == 0 ? 'S' : value.value == 1 ? 'A' : 'B',
                    pageNum: 1,
                    pageSize: 20,
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        // this.init();
                        const list = res.data.data.list
                        const allRewards = list.flatMap(item => item.rewards || []);
 
                        this.openModal('SeeExchangeRewards', {
                            allRewards,
                            level: value.value == 0 ?
                                '以获得S级奖池预览' : value.value == 1 ?
                                    '已获得A级奖池预览' : '已获得B级奖池预览'
                        })

                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                })
                .finally(() => {
                    this.loading.close()
                })
        },

        // 全勤奖励
        FullAttendanceFun() { 
            if (this.modeList.canClaimAttendanceReward == true) {
                this.openModal('FullAttendance', this.modeList.fullAttendanceList)
            }

        },

        //打开蒙版
        openModal(type, value) {
            if (type == "directPurchasing" || type == "buqian"
            ) {
                this.seeData = {
                    ...value,
                    drawTokenBalance: this.getActivityList.drawTokenBalance,
                    signMode: this.modeType,
                };
            }
            if (type == "RewardSelection" || type == "ExchangeRewards" ||
                type == "SeeExchangeRewards" || type == "FullAttendance") {
                this.seeData = value; 

            }
            if (type == "FullAttendance") {
                this.seeData = {
                    list: value,
                    drawTokenBalance: this.getActivityList.drawTokenBalance,
                    signMode: this.modeType,
                }; 

            }
            if (type == "PrizePool") {
                const list = this.getActivityList.prizePool;

                this.seeData = list.flatMap(item => {
                    const currentLevel = item.level;

                    // 核心修改：判断 length > 0
                    const sourceList = (item.rewards && item.rewards.length > 0)
                        ? item.rewards
                        : (item.voucher || []);

                    return sourceList.map(reward => ({
                        ...reward,
                        level: currentLevel
                    }));
                });
            }
            this.ispopUp = true;
            this.ispopUpType = "PublicPopUp";
            this.seeType = type;
        },

        // 每日任务
        DailyTasksFun(item) {
            this.loading = this.$loading({
                // lock: true,
                text: '领取中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            axios({
                method: "post",
                url: "/activityV2/claimDailyTask",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    signMode: this.modeType,
                    taskId: item.taskId,
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        this.init();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                })
                .finally(() => {
                    this.loading.close()
                })

        },
        // 累计任务
        CumulativeTaskTasksFun(item) {
            this.loading = this.$loading({
                // lock: true,
                text: '领取中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            axios({
                method: "post",
                url: "/activityV2/claimCumulativeTask",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    signMode: this.modeType,
                    needDays: item.needDays,
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        this.init();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                })
                .finally(() => {
                    this.loading.close()
                })

        },

        //关闭支付弹窗
        closeModal() {
            this.openPageScroll();
            this.ispopUp = false;
            this.ispopUpType = "";
        },

        go(item) {
            if (item.btnUrl.indexOf("http") != -1) {
                window.open(item.btnUrl, "_blank");
            } else {
                this.$router.push({
                    path: item.btnUrl,
                });
            }
        },
        noticeFun() {
            this.$router.push({
                path: "/notice",
            });
        },
        //蒙版抽奖
        seeReward(type) {
            this.closeModal();
            this.openLottery(type);
        },
        //打开抽奖提示
        openLotteryHit(type) {
            this.seeData = { type }
            this.openModal('tishi')
        },
        // 打开兑换弹窗
        openExchange() {
            this.seeData = this.getActivityList
            this.openModal('Exchange')
        },
        // 抽奖
        openLottery(type) {
            // 只用白金币兑换
            // if (type == "one" && this.getActivityList.exchangeTokenBalance < 2) {
            //     this.seeData = this.getActivityList
            //     this.openModal('Exchange')
            //     return
            // } else if (type == "ten" && this.getActivityList.exchangeTokenBalance < 20) {
            //     this.seeData = this.getActivityList
            //     this.openModal('Exchange')
            //     return
            // }
            // 直接使用白金币抽奖
            if (type == "one" && this.getActivityList.drawTokenBalance < 2) {
                this.seeData = this.getActivityList
                // 提示跳转充值页面
                this.openModal('goRecharge')
                return
            } else if (type == "ten" && this.getActivityList.drawTokenBalance < 18) {
                this.seeData = this.getActivityList
                // 提示跳转充值页面
                this.openModal('goRecharge')
                return
            }



            let url = "";
            if (type == "one") {
                url = "/activityV2/drawOnce";
            } else {
                url = "/activityV2/drawTen";
            }
            this.loading = this.$loading({
                // lock: true,
                text: '抽奖中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            axios({
                method: "post",
                url: url,
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {

                        const prizes = res.data.data.prizes
                        const allRewards = prizes.flatMap(item => {
                            const currentLevel = item.level;

                            // 核心逻辑：优先取 rewards，如果没有或为空，则尝试取 voucher
                            // 注意：voucher 是对象，必须用 [] 包裹成数组才能使用 .map()
                            const sourceList = (item.rewards && item.rewards.length > 0)
                                ? item.rewards
                                : (item.voucher ? [item.voucher] : []);

                            return sourceList.map(reward => ({
                                ...reward,        // 保留原有的 itemImg, quantity, name 等数据
                                level: currentLevel // 注入层级信息
                            }));
                        });
                        this.seeData = { prizes, allRewards };

                        // 筛选出所有清凉碎片中 num为6或10 的条目
                        const coolArr = prizes.filter(item =>
                            item.level === 'S' || item.level === 'A' || item.level === 'B'
                        );

                        if (coolArr.length > 0) {
                            // 判断数组里有没有num=10，优先取10；没有则取6
                            const hasS = coolArr.some(item => item.level === 'S');
                            const hasA = coolArr.some(item => item.level === 'A');

                            const showNum = hasS ? "S" : hasA ? "A" : "B";

                            this.$refs.cgModalRef.show({
                                name: '鹊舞签',
                                count: showNum
                            })
                        } else {
                            this.openModal("Reward"); 

                        }

                        this.$message.success(res.data.message);
                        this.loading.close()
                        this.init();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                });
        },
        // 抽奖特效确认
        LotteryModalOK() {
            this.openModal("Reward");
        },

        // 确认兑换二次提示
        goShop_pop(item) {
            this.seeData = item;
            this.openModal("Shop");
        },

        // 关闭蒙层
        seeConfirm(msg) {
            // this.shopBuy(msg)
            if (msg.type == "shop") {
                this.shopBuy(msg.data);
            } else if (msg.type == "RewardSelection") {
                this.RewardSelectionBuy(msg.data, msg.seeData)
            } else if (msg.type == 'Exchange') {
                this.closeModal();
                this.init()
            }
        },
        RewardSelectionBuy(item, seeData) {
            this.loading = this.$loading({
                // lock: true,
                text: '领取中....',
                background: 'rgba(0, 0, 0, 0.7)'
            }); 

            axios({
                method: "post",
                url: "/activityV2/claimDrawMilestone",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    needCount: item.needCount ? item.needCount : seeData.needCount,
                    rewardNo: item.rewardNo ? item.rewardNo : "",
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        // console.log(res.data);
                        this.$message.success(`${res.data.data.rewards[0].name}` + '领取成功');
                        this.closeModal();
                        this.init();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                })
                .finally(() => {
                    this.loading.close()
                })
        },
        // 商品二次确定后购买
        shopBuy(item) { 

            this.loading = this.$loading({
                // lock: true,
                text: '兑换中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            axios({
                method: "post",
                url: "/activityV2/exchangeShop",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    buyNum: 1,
                    goodsId: item.goodsId,
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) { 
                        this.$message.success(res.data.message);
                        this.closeModal();
                        this.init();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                })
                .finally(() => {
                    this.loading.close()
                })
        },
        // 初始化
        async init() {
            this.loading = this.$loading({
                // lock: true,
                text: '加载中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
                // 并发请求两个接口
                const [res1] = await Promise.all([
                    axios.post(
                        "/activityV2/getInfo",
                        {
                            userId: Cookies.get("wx_userId"),
                            platForm: "web",
                        },
                        {
                            headers: { token: Cookies.get("wx_token") },
                        },
                    ),

                    // axios.post("/activity/getActivityData", {
                    //     activityName: "20260520_activity",
                    //     userId: Cookies.get("wx_userId"),
                    //     platForm: "web",
                    // }, {
                    //     headers: { token: Cookies.get("wx_token") }
                    // })
                ]);

                // 处理第一个接口
                if (res1.data.state == 200) {
                    const data = res1.data.data;
                    this.getActivityList = data;
                    this.getActivityData = data.shopList;

                    this.switchMode(this.modeType)
                } else {
                    this.$message.error(res1.data.message);
                }

                // 处理第二个接口
                // if (res2.data.state === 200) {
                //     const data = res2.data.data;
                //     this.totalData = data.totalData;

                //     this.getActivityData = data.goodsWithItems

                // } else {
                //     this.$message.error(res2.data.message);
                // }
            } catch (err) {
                this.$message.error("数据加载失败，请刷新重试");
                console.error(err);
            }
            finally {
                this.loading.close()
            }
        },

        // 关闭页面滚动条
        closePageScroll() {
            document.body.style.overflow = "hidden";
            document.documentElement.style.overflow = "hidden";
        },

        // 开启页面滚动条
        openPageScroll() {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
        },
    },
};
</script>

<style>
.headerWX {
    width: 100% !important;
    position: fixed !important;
    top: 0 !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
}
</style>

<style lang="less" scoped>
.qixi_container {
    min-width: 1200px;

    .content {
        margin: 0 auto;
        padding-bottom: 50px;
        max-width: 2000px;
        width: 100%;
        position: relative;

        .bg {
            width: 100%;
            height: 100%;
            position: absolute;
            // top: 0;
        }
    }

    .pubile {
        width: fit-content;
        margin: auto;
        position: relative;
    }

    .Lottery {
        width: 65%;

        .tit {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;

            .lift {
                display: flex;
                width: 28%;
                justify-content: space-between;
                position: relative;
                z-index: 30;

                >img {
                    width: 23%;
                    max-width: 80px;
                }
            }

            .tit_bg {
                width: 28%;
                max-width: 300px;
            }

            .right {
                position: relative;
                width: 22%;
                max-width: 260px;

                >img {
                    width: 100%;
                    max-width: 260px;
                }

                .coin {
                    width: 80%;
                    text-align: center;
                    position: absolute;
                    top: 55%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: flex;
                    gap: 20px;
                    align-items: center;
                    justify-content: center;

                    .coin_num {
                        font-size: 1.3em;
                        font-weight: 700;
                        color: #fff;
                        text-shadow: -1px -1px 0 #D22190, 1px -1px 0 #D22190,
                            -1px 1px 0 #D22190, 1px 1px 0 #D22190;
                    }

                    .coin_exchange {
                        font-size: 14px;
                        padding: 5px 10px;
                        border: 1px solid #0074E1;
                        background-color: #0074E160;
                        color: #fff;
                        border-radius: 5px;
                        text-shadow: -1px -1px 0 #D22190, 1px -1px 0 #D22190,
                            -1px 1px 0 #D22190, 1px 1px 0 #D22190;
                        cursor: pointer;
                    }
                }
            }
        }

        .LotteryContent {
            width: 100%;
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            margin: 40px 0;
            position: relative;

            .LotteryContent_bg {
                width: 100%;
                height: 100%;
            }

            .items {
                position: relative;
                width: 33%;

                .jewelryBox {
                    position: relative;
                    width: 100%;
                    // height: 100%;
                    z-index: 10;
                }

                .jewelryBoxBg {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 300%;
                    /* 重点：transform 要把 translate 和 rotate 写在一起！！ */
                    transform: translate(-50%, -50%) rotate(0deg);
                    transform-origin: center center;
                    /* 轴心：元素中心（默认，可以省略，写上更清晰） */
                    animation: rotateLoop 20s linear infinite;
                }

                @keyframes rotateLoop {
                    from {
                        transform: translate(-50%, -50%) rotate(0deg);
                    }

                    to {
                        transform: translate(-50%, -50%) rotate(360deg);
                    }
                }

                .jewelry {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 130%;
                    height: 100%;
                    z-index: 11;
                }

                .bigPrize {
                    position: absolute;
                    top: 50%;
                    left: 57%;
                    width: 48%;
                    transform: translate(-50%, -50%);
                    z-index: 12;
                }
            }
        }

        .btn {
            display: flex;
            justify-content: center;
            gap: 50px;
            margin: 50px 0 20px;
            position: relative;
            z-index: 20;

            >div {
                display: flex;
                flex-direction: column;
                align-items: center;

                >img {
                    width: 100%;
                }

                p {
                    color: #fff;
                    text-shadow: -1px -1px 0 #D22190, 1px -1px 0 #D22190, -1px 1px 0 #D22190, 1px 1px 0 #D22190;

                }
            }
        }

        // 以获得的奖励道具
        .haveObtained {
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 20;

            .haveObtained_bg {
                width: 100%;
            }

            .haveObtained_list {
                position: absolute;
                bottom: 20%;
                left: 50%;
                transform: translate(-50%);
                width: 92%;
                display: flex;
                user-select: none;

                .item {
                    text-align: center;
                    width: 16.6%;

                    img {
                        max-width: 60%;
                        cursor: pointer;
                    }
                }

                .item:nth-child(3) {
                    width: 17.2%;
                }

                .item:nth-child(4) {
                    width: 18.2%;
                }

                .item:nth-child(5) {
                    width: 16.2%;
                }

                .item:nth-child(6) {
                    width: 15.2%;
                }
            }
        }

    }


    // 追加奖励
    .AdditionReward {
        width: 65%;
        text-align: center;
        position: relative;
        margin: 50px auto;

        .AdditionReward_tit {
            width: 100%;
            text-align: center;

            >img {
                width: 30%;
            }
        }

        >img {
            width: 100%;
        }

        .AdditionReward_items {
            position: absolute;
            left: 50%;
            bottom: 5%;
            transform: translateX(-50%);
            width: 85%;
            height: 68.5%;
            display: flex;
            flex-direction: column;


            >div {
                height: 20%;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .lift_award {
                width: 49%;
                // background-color: #fba0b1;
                font-size: 20px;
                color: #af25ad;
                font-weight: 600;
            }

            .right_btn {
                width: 51%;
                // background-color: #c82b3091;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;

                .Reward {
                    width: 60%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-wrap: wrap;

                    >div {
                        // width: 100%;
                    }

                    img {
                        max-width: 17%;
                        max-height: 80%;
                    }

                    :deep(.el-image__inner) {
                        max-width: 75%;
                        max-height: 80%;
                    }

                    .random {
                        display: inline-block !important;
                        color: #fff;
                        background-color: #903bdb;
                        padding: 5px 10px;
                        border-radius: 5px;
                        cursor: pointer;
                        user-select: none;
                    }
                }

                >img {
                    max-width: 20%;
                }
            }
        }
    }

    // 七夕签到
    .signIn {
        width: 65%;
        text-align: center;
        position: relative;

        .signIn_tit {
            width: 100%;
            text-align: center;

            >img {
                width: 30%;
            }
        }

        .signIn_path_bg {
            width: 100%;
        }

        .signIn_items {
            position: absolute;
            left: 50%;
            top: 55%;
            transform: translate(-50%, -50%);
            width: 70%;
            height: 65%;

            .slot_empty {
                width: 100%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            // 签到项
            .active {
                cursor: pointer;
                border: 3px solid #0074E1;
                &::before {
                    content: "";
                    position: absolute;
                    top: -4px;
                    left: -4px;
                    right: -4px;
                    bottom: -4px;
                    border-radius: 8px;
                    background: #ff00de;
                    z-index: -1;
                    animation: pulse 1.5s ease-out infinite;
                    opacity: 0;
                }

                // 脉冲动画
                @keyframes pulse {
                    0% {
                        transform: scale(0.95);
                        opacity: 0.6;
                    }

                    70% {
                        transform: scale(1.05);
                        opacity: 0;
                    }

                    100% {
                        transform: scale(0.95);
                        opacity: 0;
                    }
                }
            }

            .signIn_item {
                position: absolute;
                display: flex;
                gap: 3px;

                .reward {
                    border: #af25ad 2px solid;
                    border-radius: 10px;
                    width: 65px;
                    height: 65px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;

                    .item_img {
                        max-width: 40px;
                        max-height: 40px;
                    }

                    // 锁住
                    .icon_locked {
                        width: 80%;
                        // height: 20px;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }

                    // 补签
                    .btn_resign {
                        width: 50%;
                        // height: 20px;
                        position: absolute;
                        bottom: 0%;
                        right: 0%;
                    }
                }


            }

            .signIn_item:nth-of-type(1) {
                top: -3%;
                left: 26%;
            }

            .signIn_item:nth-of-type(2) {
                top: -3%;
                left: 54%;
            }

            .signIn_item:nth-of-type(3) {
                top: 15%;
                right: -12%;
                flex-direction: column;
            }

            .signIn_item:nth-of-type(4) {
                top: 53%;
                right: 21%;
            }

            .signIn_item:nth-of-type(5) {
                top: 53%;
                right: 54%;
            }

            .signIn_item:nth-of-type(6) {
                top: 52%;
                left: -12%;
                flex-direction: column;
            }

            .signIn_item:nth-of-type(7) {
                top: 87%;
                left: 26%;
            }

            .signIn_item:nth-of-type(8) {
                top: 87%;
                right: 25%;
            }
        }

        .signIn_mode {
            position: absolute;
            right: 30px;
            top: 22px;

            display: flex;
            gap: 12px;

            z-index: 20;

            .mode_item {
                position: relative;

                height: 32px;
                padding: 0 14px;

                display: flex;
                align-items: center;
                gap: 6px;

                color: #bd25b8;

                font-size: 13px;
                font-weight: bold;

                background: rgba(255, 255, 255, .9);

                border: 1px solid #bd25b8;
                border-radius: 18px;

                cursor: pointer;

                transition: .2s;

                .dot {
                    width: 7px;
                    height: 7px;

                    border-radius: 50%;

                    background: #d8a8d5;
                }

                &.active {
                    color: #fff;

                    background: #bd25b8;

                    box-shadow: 0 2px 5px rgba(189, 37, 184, .25);

                    .dot {
                        background: #fff;
                    }
                }
            }
        }
    }

    // 每日任务
    .DailyTasks {
        width: 65%;
        text-align: center;
        position: relative;
        margin: 50px auto;

        .DailyTasks_tit {
            width: 100%;
            text-align: center;

            >img {
                width: 30%;
            }
        }

        .DailyTasks_bg {
            width: 100%;
        }

        .DailyTasks_items {
            position: absolute;
            left: 49.5%;
            bottom: 8%;
            transform: translateX(-50%);
            width: 88%;
            height: 48%;

            .item {
                height: 33.33%;
                display: flex;
                align-items: center;
                justify-content: center;

                >div {
                    width: 50%;
                }

                .left {
                    font-size: 20px;
                    color: #af25ad;
                    font-weight: 600;
                }

                .right {
                    font-size: 20px;
                    color: #af25ad;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;

                    .right_Reward {
                        width: 50%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-evenly;


                        >img {
                            max-height: 80%;
                        }

                        .random {
                            display: inline-block !important;
                            color: #fff;
                            background-color: #903bdb;
                            padding: 5px 10px;
                            border-radius: 5px;
                            cursor: pointer;
                            user-select: none;
                        }
                    }

                    .right_Btn {
                        width: 50%;

                        >img {
                            max-width: 70px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }

    // 心直购
    .directPurchasing {
        width: 65%;
        text-align: center;
        position: relative;
        margin: 50px auto;

        .directPurchasing_tit {
            width: 100%;
            text-align: center;
        }

        .directPurchasing_num {
            margin: 30px 0;
            position: relative;

            .n_l {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);

                >div {
                    font-size: 20px;
                    font-weight: 700;
                    color: #fff;
                    text-shadow: -1px -1px 0 #D22190, 1px -1px 0 #D22190, -1px 1px 0 #D22190, 1px 1px 0 #D22190;
                }
            }
        }

        .directPurchasing_items {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .directPurchasing_item {
                gap: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;

                .Content {
                    position: absolute;
                    top: 0%;
                    left: 50%;
                    transform: translate(-50%, 0%);
                    width: 100%;
                    height: 79%;
                    display: flex;
                    align-items: center;
                    justify-content: space-evenly;
                    flex-direction: column;

                    p {
                        font-size: 16px;
                        font-weight: 600;
                        color: #fff;
                        text-shadow: -1px -1px 0 #D22190, 1px -1px 0 #D22190, -1px 1px 0 #D22190, 1px 1px 0 #D22190;
                    }
                }

                .btn {
                    cursor: pointer;
                }
            }
        }
    }


    // 金铃铛
    .Goldenbell {
        width: fit-content;
        margin: auto;
        position: relative;
        margin-top: 30px;

        .numberBady {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%);
            width: 92%;
            height: 39%;
            display: flex;
            align-items: center;
            justify-content: space-around;

            >div {
                font-size: 32px;
                font-weight: bold;
                color: #D22190;
            }
        }
    }

    // 活动商店
    .WinterStore {
        width: 75%;
        margin: auto;
        position: relative;
        margin-top: 10px;

        .tit {
            width: fit-content;
            height: fit-content;
            margin: auto;
            margin-bottom: 50px;
        }

        .shopBady {
            width: 90%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: auto;

            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;
                width: 18%;

                .BoutiqueStore_select {
                    margin-top: 20px;
                }

                .item_btn {
                    width: 85%;
                    text-align: center;
                    margin: 10px 0;

                    >img {
                        max-width: 90%;
                    }

                    .shortageText {
                        position: relative;
                        border: none;
                        outline: none;
                        /* 尺寸按需调整 */
                        width: 90%;
                        border-radius: 999px;
                        /* 胶囊超大圆角 */
                        background: rgba(145, 210, 255, 0.65);
                        /* 外层发光描边 */
                        box-shadow: 0 0 0 3px #b4f0ff, 0 0 14px #87e8ff;
                        font-size: 14px;
                        color: #ffffff;
                        font-weight: bold;
                        /* 文字蓝色外发光，复刻图中字体效果 */
                        text-shadow: 0 0 4px #3498eb, 1px 1px 3px #2986d8;
                        cursor: pointer;
                        transition: all 0.2s;
                        padding: 10px 0;
                        margin: auto;
                        margin-top: 10px;
                    }

                    /* hover 悬浮提亮，游戏按钮交互 */
                    .shortageText:hover {
                        background: rgba(158, 218, 255, 0.8);
                        box-shadow: 0 0 0 3px #c6f5ff, 0 0 20px #96eeff;
                    }
                }

                .item_number {
                    margin-bottom: 50px;
                    color: rgb(255, 255, 255);
                    font-size: 20px;
                    text-shadow: -1px -1px 0 #D22190, 1px -1px 0 #D22190, -1px 1px 0 #D22190, 1px 1px 0 #D22190;
                }

                .itemBady {
                    position: absolute;
                    top: 1%;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 70%;
                    aspect-ratio: 6 / 10;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .itemBady_t {
                        width: 100%;
                        height: 20%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 30px;
                            height: 30px;
                        }

                        p {
                            font-size: 18px;
                            color: #D22190;
                        }
                    }

                    .itemBady_c {
                        width: 100%;
                        height: 58%;
                        position: relative;

                        .sex {
                            z-index: 100;
                            width: 100%;
                            height: 10%;
                            text-align: left;
                            position: absolute;
                            top: 0;
                            left: 0;

                            >img {
                                max-width: 28px;
                            }
                        }

                        .el-image {
                            justify-content: center;

                            :deep(.el-image__preview) {
                                max-width: 90%;
                                max-height: 80%;
                                width: fit-content;

                            }
                        }

                        >img {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            max-width: 90%;
                            max-height: 90%;
                            min-width: 80%;
                        }
                    }

                    .itemBady_b {
                        width: 108%;
                        height: 20%;
                        color: #D22190;
                        font-size: 15px;
                        // line-height: 50px;
                        font-weight: bold;
                        position: relative;
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                    }
                }
            }
        }
    }


    #mask {
        height: 100vh;
        width: 100vw;
        position: fixed;
        top: 0;
        background-color: #686767cf;
        z-index: 100;
    }

    /deep/.footerWX {
        position: relative;
    }
}
</style>
